module.exports = __webpack_public_path__ + "img/information.f912f9ac.svg";